import React, { useState, useEffect } from 'react';

const getRandomkey = () => Date.now().toString(36);

const WindowDispatch = ({children}) => {
  const [mainKey, setMainKey] = useState(getRandomkey());

  useEffect(() => {
    const handleReload = () =>
      setTimeout(() => {
        setMainKey(getRandomkey());
      }, 1000);

    window.addEventListener("refresh", handleReload);
    return () => {
      window.removeEventListener("refresh", handleReload);
    };
  }, []);

  return <div key={mainKey}>{children}</div>;
};

export default WindowDispatch;